<template>
  <v-tab-item :key="3" :value="'tab-3'">
    <v-row justify="center">
      <v-col cols="12">
        <v-card ref="form" outlined flat>
          <v-card-text>
            <v-text-field
              ref="name"
              v-model="name"
              label="Học Sinh"
              placeholder="Nhập tên học sinh"
              required
            ></v-text-field>
            <v-text-field
              ref="parentName"
              v-model="parentName"
              label="Phụ Huynh"
              placeholder="Nhập tên phụ huynh"
            ></v-text-field>
            <v-text-field
              ref="email"
              v-model="email"
              label="Email Học Sinh"
              placeholder="Nhập email học sinh"
            ></v-text-field>
            <v-text-field
              ref="parentEmail"
              v-model="parentEmail"
              label="Email Phụ Huynh"
              placeholder="Nhập email phụ huynh"
            ></v-text-field>
            <v-text-field ref="school" v-model="school" label="Trường" placeholder="Nhập Trường "></v-text-field>
            <v-text-field
              ref="address"
              v-model="address"
              label="Địa Chỉ"
              placeholder="Nhập địa chỉ"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn depressed small right color="red" @click="cancel">Cancel</v-btn>
            <v-btn depressed small color="green" style="margin: 0 20px" @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-tab-item>
</template>

<script>
export default {
  props: {
    contact: { type: [Object], required: true, default: () => {} }
  },
  data: () => ({
    valid: true,
    name: '',
    email: '',
    parentEmail: '',
    school: '',
    address: '',
    parentName: ''
  }),

  methods: {
    save () {
      this.$emit('save', {
        name: this.name,
        email: this.email,
        parentEmail: this.parentEmail,
        school: this.school,
        address: this.address,
        parentName: this.parentName
      })
    },
    cancel () {
      this.name = this.contact.name
      this.email = this.contact.email
      this.parentName = this.contact.parentName
      this.parentEmail = this.contact.parentEmail
      this.address = this.contact.address
      this.school = this.contact.school
      this.$emit('cancel')
    }
  },
  watch: {
    contact (contact) {
      this.name = contact.name
      this.email = contact.email
      this.parentName = contact.parentName
      this.parentEmail = contact.parentEmail
      this.school = contact.school
      this.address = contact.address
    }
  }
}
</script>

<style scoped>
</style>
